import type { FieldValues, UseFormSetError } from 'libs/form'

// DRF sends a string, a list of strings, or a nested serializer's { field: [...] }
const toMessage = (value: unknown): string => {
	if (typeof value === 'string') return value
	const parts = Array.isArray(value) ? value : Object.values(value ?? {})
	return parts.map(toMessage).join(', ')
}

export const applyCouponServerErrors = (
	data: Record<string, unknown> | undefined,
	setError: UseFormSetError<FieldValues>
) => {
	for (const [field, value] of Object.entries(data ?? {})) {
		setError(field === 'price_discount' ? 'price_discount_value' : field, {
			message: toMessage(value)
		})
	}
}
